import React, { useEffect, useRef, useState } from "react";

// Overflow "⋮" menu for table rows with many actions.
// actions: [{ label, icon?, onClick, variant?, disabled?, title? }]
const RowActionsMenu = ({ actions }) => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;

        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        const handleKeyDown = (event) => {
            if (event.key === "Escape") setOpen(false);
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [open]);

    const handleActionClick = (action) => {
        if (action.disabled) return;
        action.onClick();
        setOpen(false);
    };

    return (
        <div className="btc-row-actions-menu" ref={containerRef}>
            <button
                type="button"
                className="btc-btn btn-ghost btn-sm btc-row-actions-trigger"
                onClick={() => setOpen((prev) => !prev)}
                title="More actions"
                aria-label="More actions"
                aria-haspopup="true"
                aria-expanded={open}
            >
                &#8942;
            </button>
            {open && (
                <div className="btc-row-actions-popover">
                    {actions.map((action) => (
                        <button
                            type="button"
                            key={action.label}
                            className={`btc-row-actions-item ${action.variant ? `btc-row-actions-item-${action.variant}` : ""}`}
                            onClick={() => handleActionClick(action)}
                            disabled={Boolean(action.disabled)}
                            title={action.title}
                        >
                            {action.icon && <span className="btc-row-actions-item-icon">{action.icon}</span>}
                            <span>{action.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RowActionsMenu;
